module.exports = __webpack_public_path__ + "assets/img/0c9a9ac50c41a97ccd3d4a539df3e1ef.png";